import React, { Component } from 'react'
import PropTypes from 'prop-types'
import CSSModules from 'react-css-modules'
import { Flex } from 'reflexbox'

import Button from 'components/fulcrum/button/FulcrumButton'

import styles from './styles.scss'

const NavigationLink = (props) => {
  const {
    label,
    onClick,
  } = props

  return (
    <Flex align='center'>
      <Button
        theme={styles}
        onClick={onClick}
        label={label}
        flat
      />
    </Flex>
  )
}

NavigationLink.propTypes = {
  onClick: PropTypes.func,
  label: PropTypes.string.isRequired,
}

NavigationLink.defaultProps = {
  label: '',
}

export default CSSModules(NavigationLink, styles)
